{
  "name": "govigilant-admin",
  "version": "0.4.4",
  "private": true,
  "scripts": {
    "ng": "ng",
    "build": "ng build",
    "start": "ng serve",
    "start-ssl": "ng serve --ssl --ssl-cert \"localhost.crt\" --ssl-key \"localhost.key\"",
    "rev": "npm --no-git-tag-version version patch",
    "i18n": "ng extract-i18n --format=xlf --output-path src/locale/terms --out-file app-terms.xlf",
    "prettier": "prettier ./src/**/{*.ts,*.html} -w",
    "lint": "npm run eslint && npm run stylelint",
    "eslint": "eslint ./src/**/{*.ts,*.html}",
    "stylelint": "stylelint ./src/**/*.scss"
  },
  "dependencies": {
    "@angular/animations": "^19.1.6",
    "@angular/common": "^19.1.6",
    "@angular/compiler": "^19.1.6",
    "@angular/core": "^19.1.6",
    "@angular/forms": "^19.1.6",
    "@angular/platform-browser": "^19.1.6",
    "@angular/platform-browser-dynamic": "^19.1.6",
    "@angular/router": "^19.1.6",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/effects": "^19.0.1",
    "@ngrx/router-store": "^19.0.1",
    "@ngrx/store": "^19.0.1",
    "@primeng/themes": "^19.0.6",
    "oidc-client-ts": "^3.1.0",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.0.6",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.7",
    "@angular-eslint/eslint-plugin": "^19.1.0",
    "@angular-eslint/template-parser": "^19.1.0",
    "@angular/cli": "^19.1.7",
    "@angular/compiler-cli": "^19.1.6",
    "@ngrx/eslint-plugin": "^19.0.1",
    "@ngrx/store-devtools": "^19.0.1",
    "@types/jasmine": "^5.1.6",
    "@types/node": "^22.13.4",
    "@typescript-eslint/eslint-plugin": "^8.24.1",
    "@typescript-eslint/parser": "^8.24.1",
    "eslint": "^9.20.1",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-prettier": "^5.2.3",
    "jasmine-core": "^5.6.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "prettier": "^3.5.1",
    "stylelint": "^16.14.1",
    "stylelint-config-standard": "^37.0.0",
    "stylelint-config-standard-scss": "^14.0.0",
    "stylelint-scss": "^6.11.0",
    "typescript": "~5.7.3"
  }
}
